import baseRequest from "../_core/baseRequest";

export const supplierService = {
    supplierList: params => baseRequest.get(`/supplier${baseRequest.queryString(params, {})}`),
    supplierInfo: params => baseRequest.get(`/supplier/${params.supplierId}`),
    updateSupplier: params => baseRequest.put(`/supplier/${params.supplierId}`, params),
    createSupplier: params => baseRequest.post(`/supplier`, params),
    patchSupplier: params => baseRequest.patch(`/supplier/${params.supplierId}`, params),
    updateSupplierSecret: params => baseRequest.post(`/supplier/${params.supplierId}/update-secret`),
    deleteSupplier: params => baseRequest.delete(`/supplier/${params.supplierId}`),
};

export default supplierService;
